import CircularProgress from "@mui/material/CircularProgress";
import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import logoSpinner from "images/logoSpinner.svg";

type Props = {
  className?: string;
  color?: string;
  size?: number;
  style?: CSSProperties;
};

// Any styling prop switches the spinner from the branded logo to a plain MUI ring.
export default function TalaeraSpinner(props: Props) {
  if (props.className || props.color || props.size || props.style) {
    return (
      <CircularProgress
        size={props.size ? props.size : 40}
        className={props.className ? props.className : "spinner"}
        style={{
          color: props.color ? props.color : "var(--action-brand)",
          ...props.style,
        }}
      />
    );
  }

  return <LogoSpinner />;
}

function LogoSpinner() {
  const { t } = useTranslation();

  return (
    <img
      src={logoSpinner}
      alt={t("Common.spinner.loadingLabel")}
      style={{ width: 50, marginTop: 20 }}
    />
  );
}
